/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';

/**
 * 
 * @export
 * @interface ExportSearch
 */
export interface ExportSearch {
    /**
     * 
     * @type {number}
     * @memberof ExportSearch
     */
    idModule?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExportSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ExportSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ExportSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExportSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ExportSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ExportSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ExportSearch interface.
 */
export function instanceOfExportSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExportSearchFromJSON(json: any): ExportSearch {
    return ExportSearchFromJSONTyped(json, false);
}

export function ExportSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idModule': !exists(json, 'idModule') ? undefined : json['idModule'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ExportSearchToJSON(value?: ExportSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idModule': value.idModule,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

